import { render, staticRenderFns } from "./CallReactiveProject.vue?vue&type=template&id=35cbbfd2"
import script from "./CallReactiveProject.vue?vue&type=script&lang=js"
export * from "./CallReactiveProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports